<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>

      <div class="page-wrapper">
        <div class="content container-fluid waajo-ticket-detail-page">
          <button type="button" class="waajo-ticket-back" @click="goBack">
            <i class="fa fa-angle-left"></i> Kembali ke Ticket
          </button>

          <ticket-detail-panel :ticket-id="ticketId" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TicketDetailPanel from './components/TicketDetailPanel.vue'

export default {
  name: 'TicketDetail',
  components: {
    TicketDetailPanel
  },
  computed: {
    ticketId() {
      return this.$route.params.id
    }
  },
  methods: {
    goBack() {
      this.$router.push('/ticket/list')
    }
  }
}
</script>

<style scoped>
.waajo-ticket-detail-page {
  padding-top: 22px;
}
.waajo-ticket-back {
  border: 0;
  background: transparent;
  color: var(--waajo-text-muted);
  font-size: 14px;
  font-weight: 600;
  padding: 0;
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/ticket/detail.vue